import { ActionTree } from 'vuex';

export default <ActionTree<webparts.state.WebpartsState, RootState>>{
};
